var _path, _path2, _g, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLongDistance({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 104,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0228 7.78535C42.3036 6.46852 45.1137 6.46852 47.3945 7.78535L76.7314 24.723C79.0122 26.0398 80.4172 28.4734 80.4172 31.1071V64.9824C80.4172 67.6161 79.0122 70.0497 76.7314 71.3665L47.3945 88.3042C45.1137 89.621 42.3036 89.621 40.0227 88.3042L10.6859 71.3665C8.40504 70.0497 7 67.6161 7 64.9824V31.1071C7 28.4734 8.40504 26.0398 10.6859 24.723L40.0228 7.78535Z",
    fill: "#FFDCC1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9195_19689",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 12,
    width: 65,
    height: 72
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.864 12.9152C42.7172 11.8453 45.0004 11.8453 46.8535 12.9152L72.7845 27.8865C74.6377 28.9564 75.7793 30.9337 75.7793 33.0736V63.0161C75.7793 65.156 74.6377 67.1333 72.7845 68.2032L46.8535 83.1745C45.0004 84.2444 42.7172 84.2444 40.864 83.1745L14.933 68.2032C13.0798 67.1333 11.9382 65.156 11.9382 63.0161V33.0736C11.9382 30.9337 13.0798 28.9564 14.933 27.8865L40.864 12.9152Z",
    fill: "#C14F0E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9195_19689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.864 12.9152C42.7172 11.8453 45.0004 11.8453 46.8535 12.9152L72.7845 27.8865C74.6377 28.9564 75.7793 30.9337 75.7793 33.0736V63.0161C75.7793 65.156 74.6377 67.1333 72.7845 68.2032L46.8535 83.1745C45.0004 84.2444 42.7172 84.2444 40.864 83.1745L14.933 68.2032C13.0798 67.1333 11.9382 65.156 11.9382 63.0161V33.0736C11.9382 30.9337 13.0798 28.9564 14.933 27.8865L40.864 12.9152Z",
    fill: "#FA823E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M107.846 45.06C72.2298 83.5011 12.5546 43.3756 6.58582 9.86806L-27.8162 57.6638L55.5728 117.685L107.846 45.06Z",
    fill: "#C14F0E"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 51.25C17.7522 63.5 31.75 68.75 44 68.75C56.6 68.75 69.375 62.625 70.2479 51.25C71.1207 39.875 63.25 27.625 59.75 27.625C56.25 27.625 59.75 33.75 56.25 33.75C54.8375 33.75 54.2775 29.7598 52.75 25C50.4925 17.9655 47.1313 9.25 44 9.25C41.1242 9.25 37.1759 18.3511 35.25 25C33.66 30.4893 34.1242 33.75 31.75 33.75C28.25 33.75 31.9234 27.625 28.25 27.625C23 27.625 17.7482 40.7267 17.75 51.25Z",
    fill: "#FCCE2C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3066 53.2711L42.9827 37.3651C43.3878 36.6224 44.4748 36.687 44.789 37.4726L47.5 44.25H51.9753C52.7263 44.25 53.2093 45.0468 52.8619 45.7126L44.4738 61.7897C44.0333 62.634 42.7737 62.443 42.6034 61.5061L41.375 54.75H35.1845C34.4255 54.75 33.9432 53.9375 34.3066 53.2711Z",
    fill: "#FFECA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongDistance);
export default __webpack_public_path__ + "static/media/long-distance.42fecd86f838eae5ca9186582f995ec3.svg";
export { ForwardRef as ReactComponent };